import { facetEngagementAdapter } from './facet';
import { bannerEngagementAdapter } from './banner';
import { modelToggleEngagementAdapter } from './model-toggle';
import { EngagementsString } from '../types';
export { dynamicFacetNameEnabled } from './facet';

export const engagementsString = ({
  queryString,
  facetData,
  appliedQuickFacets,
  modelToggleData,
}: EngagementsString) => {
  return [
    facetEngagementAdapter(facetData, appliedQuickFacets),
    bannerEngagementAdapter(queryString),
    modelToggleEngagementAdapter(modelToggleData),
  ]
    .filter((engagement) => !!engagement)
    .join(' | ');
};
